/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';

/**
 * 
 * @export
 * @interface MonitoredObjectGroupNested
 */
export interface MonitoredObjectGroupNested {
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectGroupNested
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectGroupNested
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectGroupNested
     */
    color?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectGroupNested
     */
    monitoredObjectGroupType?: number | null;
    /**
     * 
     * @type {Client}
     * @memberof MonitoredObjectGroupNested
     */
    client?: Client;
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectGroupNested
     */
    readonly deleted?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredObjectGroupNested
     */
    automaticVehicleAdd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredObjectGroupNested
     */
    readonly deletable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectGroupNested
     */
    clientId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectGroupNested
     */
    readonly monitoredObjects?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectGroupNested
     */
    readonly users?: Array<number>;
}

export function MonitoredObjectGroupNestedFromJSON(json: any): MonitoredObjectGroupNested {
    return MonitoredObjectGroupNestedFromJSONTyped(json, false);
}

export function MonitoredObjectGroupNestedFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectGroupNested {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'monitoredObjectGroupType': !exists(json, 'monitored_object_group_type') ? undefined : json['monitored_object_group_type'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'automaticVehicleAdd': !exists(json, 'automatic_vehicle_add') ? undefined : json['automatic_vehicle_add'],
        'deletable': !exists(json, 'deletable') ? undefined : json['deletable'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'monitoredObjects': !exists(json, 'monitored_objects') ? undefined : json['monitored_objects'],
        'users': !exists(json, 'users') ? undefined : json['users'],
    };
}

export function MonitoredObjectGroupNestedToJSON(value?: MonitoredObjectGroupNested | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color': value.color,
        'monitored_object_group_type': value.monitoredObjectGroupType,
        'client': ClientToJSON(value.client),
        'automatic_vehicle_add': value.automaticVehicleAdd,
        'client_id': value.clientId,
    };
}


